import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import _get from 'lodash/get';
import { Table } from 'ui-base';
import { TableHead } from './TableHead';
import { TableRow } from './TableRow';
import styles from './Table.module.scss';

class DataTable extends Component {
  state = { columns: [] };

  /**
   * Check items for each column and remove the columns that all values are undefined
   * @returns {Object} - the derived state that contains defines the columns structure
   */
  static getDerivedStateFromProps(nextProps) {
    const { columns, items, hideUndefinedColumns } = nextProps;
    if (hideUndefinedColumns) {
      return {
        columns: columns.reduce((acc, column) => {
          const isColumnDefined = items.some(
            item => _get(item, column.id, undefined) !== undefined
          );
          return isColumnDefined ? [...acc, column] : acc;
        }, [])
      };
    }
    return { columns };
  }

  renderRows = () => {
    const { items, clickHandler, hasCellMinWidth, centeredText } = this.props;

    return (
      items.map(item => (
        <TableRow
          onClick={clickHandler ? () => clickHandler(item) : null}
          key={item.id}
          columns={this.state.columns}
          item={item}
          centeredText={centeredText}
          hasCellMinWidth={hasCellMinWidth}
        />
      ))
    );
  };

  render = () => {
    const { className, hoverable, bordered, striped, headerBordered, hasCellMinWidth, centeredText } = this.props;
    return (
      <div className={classnames('table-container', className)}>
        <Table
          className={classnames(styles.table, {
            'is-hoverable': hoverable,
            [styles.bordered]: bordered
          })}
          bordered={bordered}
          striped={striped}
        >
          <TableHead columns={this.state.columns} noBordered={!headerBordered} hasCellMinWidth={hasCellMinWidth} centeredText={centeredText} />
          <tbody>
            {this.renderRows()}
          </tbody>
        </Table>
      </div>
    );
  };
}

DataTable.propTypes = {
  bordered: PropTypes.bool,
  className: PropTypes.string,
  columns: PropTypes.array.isRequired,
  hoverable: PropTypes.bool,
  items: PropTypes.array.isRequired,
  striped: PropTypes.bool,
  clickHandler: PropTypes.func,
  hideUndefinedColumns: PropTypes.bool,
  headerBordered: PropTypes.bool,
  hasCellMinWidth: PropTypes.bool,
  centeredText: PropTypes.bool,
};

DataTable.defaultProps = {
  bordered: true,
  className: null,
  hoverable: false,
  striped: true,
  hideUndefinedColumns: false,
  clickHandler: null,
  headerBordered: false,
  hasCellMinWidth: false,
  centeredText: false,
};

export { DataTable };
